module.exports = __webpack_public_path__ + "static/media/project-management.a07a369b.svg";